export default "<app-frame-work-body></app-frame-work-body>\r\n"